import { Phone, MessageSquare } from "lucide-react";

const tel = (p) => p.replace(/[^\d+]/g, "");
const btn = "inline-grid place-items-center h-7 w-7 rounded-full border border-slate-700 text-slate-300 hover:text-emerald-300 hover:border-emerald-500/50 transition-colors";

export const PhoneLinks = ({ phone, testId, className = "" }) => {
  if (!phone?.trim()) return null;
  return (
    <span className={`inline-flex items-center gap-1.5 ${className}`} data-testid={testId}>
      <span>{phone}</span>
      <a href={`tel:${tel(phone)}`} className={btn} title={`Call ${phone}`} aria-label={`Call ${phone}`} data-testid={`${testId}-call`}><Phone className="h-3.5 w-3.5" /></a>
      <a href={`sms:${tel(phone)}`} className={btn} title={`Text ${phone}`} aria-label={`Text ${phone}`} data-testid={`${testId}-text`}><MessageSquare className="h-3.5 w-3.5" /></a>
    </span>
  );
};
